import * as React from 'react';
import { generateInnerHtml } from '@blend/shared-react';

import ErrorMessage from 'login-components/Common/Notifications/ErrorMessage/ErrorMessage';
import './PrivacyPolicyViewer.scss';

interface PrivacyPolicyViewerProps {
  htmlText: string;
  error?: string;
}

class PrivacyPolicyViewer extends React.Component<PrivacyPolicyViewerProps, {}> {
  render() {
    const { htmlText, error } = this.props;

    return (
      <div className="PrivacyPolicyViewer">
        <div className="PrivacyPolicyViewer-body">
          <div className="PrivacyPolicyViewer-contentWrapper">
            <div
              className="PrivacyPolicyViewer-htmlText BrandLinks"
              // We allow img here in addition to other tags because we embed images
              {...generateInnerHtml(htmlText, ['img'])}
            />
          </div>
        </div>
        <div className="PrivacyPolicyViewer-normalizeWidthWrapper">
          {error && /* istanbul ignore next: (UI-5482) */ <ErrorMessage errorText={error} />}
        </div>
      </div>
    );
  }
}

export default PrivacyPolicyViewer;
